import './References.scss';

import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  ReferencesDefaultProps,
  ReferencesPropTypes,
} from './References.proptypes';

const References = ({
  className,
  codeOldCompanySku,
  manufacturerSku,
  sku,
  isLightDisplay,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn('product-references', className, {
        'product-references-light': isLightDisplay,
      })}
    >
      <div
        className={cn('list list--references', {
          'list--references-light': isLightDisplay,
        })}
      >
        <span className="list__item" data-qa-id="sku">
          <span className="label" data-qa-id="label">
            {t('common:entities:product.sku')}
          </span>
          <span className="value" data-qa-id="value">
            {sku || '--'}
          </span>
          {codeOldCompanySku && (
            <span className="sub-value">
              {' '}
              ({t('common:entities:product.old_sku')} : {codeOldCompanySku})
            </span>
          )}
        </span>
        <span className="list__score"> &nbsp;-&nbsp; </span>
        <span className="list__item" data-qa-id="manufacturer-sku">
          <span className="label" data-qa-id="label">
            {t('common:entities:product.manufacturer_sku')}
          </span>
          <span className="value" data-qa-id="value">
            {manufacturerSku || '--'}
          </span>
        </span>
      </div>
    </div>
  );
};

References.defaultProps = {
  ...ReferencesDefaultProps,
};

References.propTypes = {
  ...ReferencesPropTypes,
};

export default References;
